import anime from "animejs";
import { useCropperStore } from "../store/cropper/cropper-store";

export function useAnimation() {
  const cropperStore = useCropperStore();
  const animations = {
    center: () => {
      const position = {
        source: cropperStore.element.cropper.getCanvasData(),
        target: cropperStore.element.cropper._getCenter(
          cropperStore.element.cropper.getCanvasData()
        ),
        left: 0,
        top: 0,
      };
      return {
        targets: position,
        left: [ position.source.left, position.target.left ],
        top: [ position.source.top, position.target.top ],
        update: () => {
          cropperStore.element.cropper.setCanvasData(position);
        }
      };
    },
    zoom: (params) => {
      // console.log(params);
      // console.log(cropperStore.element.cropper._getCanvasCenterPivot());
      const zoom = {
        value: cropperStore.element.cropper._getZoomFactor(),
        ...cropperStore.element.cropper._getCanvasCenterPivot()
      }
      const animation = {
        targets: zoom,
        value: params.data.value,
        left: params.data.pivot.left,
        top: params.data.pivot.top,
        update: (anim) => {
          cropperStore.element.cropper[params.func](zoom.value, { left: zoom.left, top: zoom.top });
        },
      };
      return animation;
    }
  }
  return function animate(animName, params, options = {}) {
    return anime({
      easing: 'easeInOutSine',
      duration: 500,
      ...animations[animName](params),
      ...options,
    });
  }
}